import { render, staticRenderFns } from "./tender.vue?vue&type=template&id=139dc0d0&scoped=true"
import script from "./tender.vue?vue&type=script&lang=js"
export * from "./tender.vue?vue&type=script&lang=js"
import style0 from "./tender.vue?vue&type=style&index=0&id=139dc0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139dc0d0",
  null
  
)

export default component.exports